module.exports = __webpack_public_path__ + "img/spread_profile_example_recommends_mobile.ea923d4a.png";